<template>
  <span>{{title}}</span>
</template>

<script>
export default {
  name: "OperationHeader",
  props: ["title"],
  data() {
    return {};
  }
};
</script>

<style>

</style>





// WEBPACK FOOTER //
// src/components/shared/OperationHeader.vue